const validate = (value, rules) => {
    let isValid = true;
    let errorMsg = null;

    for (const rule in rules) {
        switch (rule) {
        case Object.keys(rules).find((k) => k === 'min'):
            isValid = isValid && minLengthValidator(value, rules[rule].value);
            errorMsg = rules[rule].errorMsg;
            break;

        case Object.keys(rules).find((k) => k === 'max'):
            isValid = isValid && maxLengthValidator(value, rules[rule].value);
            errorMsg = rules[rule].errorMsg;
            break;

        case Object.keys(rules).find((k) => k === 'isRequired'):
            isValid = isValid && requiredValidator(value, rules[rule].value);
            errorMsg = rules[rule].errorMsg;
            break;

        case Object.keys(rules).find((k) => k === 'pattern'):
            isValid = isValid && patternValidator(value, rules[rule].value, rules.isRequired.value);
            errorMsg = rules[rule].errorMsg;
            break;

        default:
            isValid = true;
            break;
        }

        if (!isValid && errorMsg !== null) {
            break;
        }
    }

    return [
        isValid,
        errorMsg
    ];
};

/**
 * MinLength Val
 * @param  value
 * @param  minLength
 * @return
 */
const minLengthValidator = (value, minLength) => {
    if (typeof value === 'number') {
        return value >= minLength;
    }
    return value.length >= minLength;
};

/**
 * Check to confirm that field is required
 * @param value
 * @param isRequired
 * @return {boolean}
 */
const requiredValidator = (value, isRequired) => {
    if (isRequired) {
        if (value === null) {
            return false;
        }
        if (typeof value === 'number') {
            return true;
        }
        if (value instanceof Date) {
            return true;
        }
        if (value instanceof Object) {
            return true;
        }
        return value.trim() !== '';
    }
    return true;
};

/**
 * MaxLength Val
 * @param  value
 * @param  maxLength
 * @return
 */
const maxLengthValidator = (value, maxLength) => {
    if (typeof value === 'number') {
        return value <= maxLength;
    }
    return value.length <= maxLength;
};

/**
 * Pattern validator
 * @param  value
 * @param  pattern
 * @return Boolean
 */
const patternValidator = (value, pattern, isRequired) => {
    if (value === '' && !isRequired) {
        return true;
    }
    if (typeof pattern === 'string') {
        return new RegExp(pattern.slice(1, -1)).test(value);
    }
    return pattern.test(value);
};

export default validate;
